import { apiClient } from '@/lib/api-client'
import type { IngredientSuggestion, Recipe, RecipeDetail, RecipeFormData } from './types'

export function getIngredientAutocomplete(query: string): Promise<IngredientSuggestion[]> {
  return apiClient.get<IngredientSuggestion[]>(`/api/v1/ingredients/autocomplete?query=${encodeURIComponent(query)}`)
}

export function createRecipe(data: RecipeFormData & { householdId?: string }): Promise<Recipe> {
  return apiClient.post<Recipe>('/api/v1/recipes', data)
}

export function getRecipes(options?: { search?: string }): Promise<Recipe[]> {
  const params = new URLSearchParams()
  if (options?.search) params.set('search', options.search)
  const qs = params.toString()
  return apiClient.get<Recipe[]>(`/api/v1/recipes${qs ? `?${qs}` : ''}`)
}

export function getRecipe(id: string): Promise<RecipeDetail> {
  return apiClient.get<RecipeDetail>(`/api/v1/recipes/${id}`)
}

export function updateRecipe(id: string, data: RecipeFormData): Promise<RecipeDetail> {
  return apiClient.put<RecipeDetail>(`/api/v1/recipes/${id}`, data)
}

export function deleteRecipe(id: string): Promise<void> {
  return apiClient.delete<void>(`/api/v1/recipes/${id}`)
}

export function toggleFavourite(id: string, isFavourite: boolean): Promise<Recipe> {
  return apiClient.patch<Recipe>(`/api/v1/recipes/${id}/favourite`, { isFavourite })
}
